import { Component } from '@angular/core';

@Component({
  selector: 'app-user-add-page',
  templateUrl: './user-add-page.component.html',
  styleUrls: ['./user-add-page.component.scss']
})
export class UserAddPageComponent {

}
